var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',_vm._g(_vm._b({staticClass:"mx-auto",attrs:{"height":"100%","max-width":"800"}},'v-card',_vm.$attrs,false),_vm.$listeners),[_c('v-card-title',{class:[
      'primary--text',
      'text-center',
      'justify-center',
      'mx-10',
      'pb-2' ]},[_c('v-icon',{staticClass:"mr-1",attrs:{"color":"primary"}},[_vm._v(_vm._s(_vm.leftTitleIcon))]),_vm._t("title")],2),_c('v-card-text',{staticClass:"mt-5",attrs:{"height":"100%"}},[_vm._t("default",function(){return [_vm._v("Description")]})],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }